import React, {useEffect, useState} from "react";
import CompanyDetails from "./CompanyDetails/CompanyDetails";
import CommissionDetails from "./CommissionDetails/CommissionDetails";
import BankDetails from "./BankDetails/BankDetails";
import ContactDetails from "./ContactDetails/ContactDetails";
import queryString from "query-string";
import {fetchHostOnboardingDataById} from "../NewHostOnboardingAction";
import {useDispatch, useSelector} from "react-redux";
import {setValuesToHostOnboardingFields} from "../../../../helper/NewHostOnboardingDataSet";
import {Form} from "antd";

const NewHostOnboardingDetails = (props) => {

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [fetchedData, setFetchedData] = useState(false);

    const { id } = queryString.parse(props.location.search);
    const newHostOnboardingDetails = useSelector(((state) => state.newHostOnboarding?.hostOnboardingDetailsById?.data || []));

    useEffect(() => {
        dispatch(fetchHostOnboardingDataById(id, setFetchedData));
    },[]);

    useEffect(() => {
        setValuesToHostOnboardingFields(form , newHostOnboardingDetails)
    },[fetchedData]);
    return(
        <>
            <Form form={form}>
                <CompanyDetails/>

                <ContactDetails/>

                <CommissionDetails/>

                <BankDetails/>
            </Form>
        </>
    )
};
export default NewHostOnboardingDetails;